export const DEFAULT_EVENT_SLUG = 'gravel-games-2027';
export const DOCUMENT_RETENTION_DAYS = 365;
export const SUPPORTED_LOCALES = ['fr', 'en'] as const;
export const DEFAULT_LOCALE = 'fr';
/** Time zone for event dates and tier cut-offs until `events.timezone` exists (PRD §7, §9). */
export const DEFAULT_TIMEZONE = 'Europe/Paris';

/**
 * Back-office MCP server (issue #47, decision 0030). One scope: the admin's own back office.
 * Access tokens are short-lived; refresh tokens rotate on every use and never outlive the
 * grant, after which the organiser signs in again.
 */
export const MCP_SCOPE = 'admin';
export const MCP_ACCESS_TOKEN_TTL_SECONDS = 60 * 60;
export const MCP_REFRESH_TOKEN_TTL_SECONDS = 60 * 60 * 24 * 30;
export const MCP_GRANT_TTL_SECONDS = 60 * 60 * 24 * 90;
/** From `GET /oauth/authorize` to the consent: room for the magic link (15 min) to arrive. */
export const OAUTH_REQUEST_TTL_SECONDS = 60 * 30;
export const OAUTH_CODE_TTL_SECONDS = 60 * 2;
